const LEGACY_API_URL = 'https://api.stage.agilox.net/api';
const NEW_API_URL = 'https://backend01-dcc.stage.agilox.net/api';
const AGENT_API_URL = '/agent';

export const environment = {
	environmentName: 'stage',
	server: LEGACY_API_URL,
	serverNew: NEW_API_URL,
	agentApi: AGENT_API_URL,
	production: false,
	excludedRoutePatterns: ['assets/images/', 'assets/i18n/'],
	cookieDomain: 'domain=.agilox.net;',
	msal: {
		clientId: 'a97390e4-5541-456b-9fff-14420ef4c4eb',
		authority: 'https://worldstageauth.ciamlogin.com/aafdd160-97ff-4c7e-b7dd-4c55b34f00cb',
		apis: {
			agilox: {
				scopes: ['api://8b96f54c-8de0-4b0f-85d7-d51b1e9c9b8e/user_impersonation'],
				baseUrl: NEW_API_URL,
			},
			legacy: {
				scopes: ['api://8761f16f-e8f4-43ef-a3cf-385449b3f156/user_impersonation'],
				baseUrl: LEGACY_API_URL,
			},
			agent: {
				scopes: ['api://b912d846-5b36-43ba-978c-8f20ac00243f/user_impersonation'],
				baseUrl: AGENT_API_URL,
			},
		},
	},
};
